import { useCallback } from 'react';
import { openToast, Toast, closeAllToasts } from '@/redux/slices/pageSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/redux/store';

type Message = string | React.ReactNode;

type UseToastReturn = {
  showSuccessMessage: (message: Message) => void;
  showFailMessage: (message: Message, icon?: string, type?: Toast['type']) => void;
  removeAllToasts: () => void;
};

const useToast = (): UseToastReturn => {
  const dispatch = useDispatch<AppDispatch>();

  const showSuccessMessage = useCallback(
    (message: Message) => {
      dispatch(
        openToast({
          type: 'confirmation',
          content: message,
          icon: 'check'
        })
      );
    },
    [dispatch]
  );

  const showFailMessage = useCallback(
    (message: Message, icon?: string, type?: Toast['type']) => {
      dispatch(
        openToast({
          type: type ?? 'alert',
          content: message,
          icon
        })
      );
    },
    [dispatch]
  );

  const removeAllToasts = useCallback(() => {
    dispatch(closeAllToasts());
  }, [dispatch]);

  return {
    showSuccessMessage,
    showFailMessage,
    removeAllToasts
  };
};

export default useToast;
